import keyMirror from 'keymirror';

export const ActionTypes = keyMirror({
  SET_SELECTED_SITE: null,
});

export interface ISelectedSitesState {
  selectedSite?: Site;
}
